import React, { useContext, useState } from "react";
import HomeLocalStateAdapter from "../../../../../pages/home/localStateAdapter";
import { HomeModel } from "../../../../../pages/home/types";
import UpdateContactInformationAdapter from "../../../../../pages/registration/updateContactInformationAdapter";
import logging from "../../../../../util/logging";
import { ApplicationFlowSteps } from "../types";
import { ProductContext } from "../../../../../context/product-context/productContext";
import { homeDefaults } from "../../../../../pages/home/defaults";
import { Product } from "../../../../../context/product-context/product";

const log = logging(
  "route/application/authenticated/application-flow/noApplicationsPresentFlow",
);

interface NoApplicationsCurrentStepProp {
  step: ApplicationFlowSteps;
  setStep: (step: ApplicationFlowSteps) => void;
  triggerReload: () => void;
}

const NoApplicationsCurrentStep = (
  props: NoApplicationsCurrentStepProp,
): React.JSX.Element => {
  const { step, setStep, triggerReload } = props;

  const { setSelectedProduct } = useContext(ProductContext);
  const [homeModel, setHomeModel] = useState<HomeModel>(homeDefaults);

  if (step === ApplicationFlowSteps.COMPANY) {
    return (
      <HomeLocalStateAdapter
        homeModel={homeModel}
        onNext={(model) => {
          setHomeModel(model);
          setStep(ApplicationFlowSteps.REGISTRATION);
        }}
        handleOnProductFamilySelection={(product: Product): void => {
          setSelectedProduct(product);
        }}
      />
    );
  }

  if (step === ApplicationFlowSteps.REGISTRATION) {
    return (
      <UpdateContactInformationAdapter
        homeModel={homeModel}
        previous={() => setStep(ApplicationFlowSteps.COMPANY)}
        next={async () => {
          triggerReload();
        }}
      />
    );
  }

  log.error(
    `Unknown application step in noApplicationsCurrentStep component: ${step}`,
  );

  return null;
};

export default NoApplicationsCurrentStep;
